
const apiConfig = {
    // LOcal
    // apiUrl: 'https://localhost:7011/api/',
    // Live
    // apiUrl: 'https://r-api.off-ease.com:44357/api/',
    // Test
     apiUrl: 'https://r-new-api.off-ease.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;
